__turbopack_context__.v({
  "dark": "PrimaryButton-module-scss-module__FgJ2xa__dark",
  "light": "PrimaryButton-module-scss-module__FgJ2xa__light",
  "primaryButton": "PrimaryButton-module-scss-module__FgJ2xa__primaryButton",
  "stack-module-0": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-0",
  "stack-module-1": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-1",
  "stack-module-10": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-10",
  "stack-module-11": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-11",
  "stack-module-12": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-12",
  "stack-module-13": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-13",
  "stack-module-14": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-14",
  "stack-module-15": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-15",
  "stack-module-16": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-16",
  "stack-module-17": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-17",
  "stack-module-18": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-18",
  "stack-module-19": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-19",
  "stack-module-2": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-2",
  "stack-module-20": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-20",
  "stack-module-3": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-3",
  "stack-module-4": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-4",
  "stack-module-5": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-5",
  "stack-module-6": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-6",
  "stack-module-7": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-7",
  "stack-module-8": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-8",
  "stack-module-9": "PrimaryButton-module-scss-module__FgJ2xa__stack-module-9",
  "z-base": "PrimaryButton-module-scss-module__FgJ2xa__z-base",
  "z-content": "PrimaryButton-module-scss-module__FgJ2xa__z-content",
  "z-footer": "PrimaryButton-module-scss-module__FgJ2xa__z-footer",
  "z-header": "PrimaryButton-module-scss-module__FgJ2xa__z-header",
  "z-hero": "PrimaryButton-module-scss-module__FgJ2xa__z-hero",
  "z-logo": "PrimaryButton-module-scss-module__FgJ2xa__z-logo",
  "z-logo-effect": "PrimaryButton-module-scss-module__FgJ2xa__z-logo-effect",
  "z-navigation": "PrimaryButton-module-scss-module__FgJ2xa__z-navigation",
  "z-sub": "PrimaryButton-module-scss-module__FgJ2xa__z-sub",
});
